// FILTER PURPOSES: stuff analogical to store data/actions,
// but need to be separated from it for purposes of views that use the same values

import serviceHandler from "@/helpers/handlers/service";
import facilitiesService from "@/services/facilities";
import { FacilityModel } from "@/utils/google/facilities/facility-model";

export const createFacilityModel = (facility, itemIndex) => {
  const model = new FacilityModel();
  model.makeFacilityModel({ facility, itemIndex });
  return model.returnFacilityModel();
};

export const facilitiesFilter = {
  data() {
    return {
      facilitiesMixin__totalCount: 0,
      facilitiesMixin__currentPageFacilities: [],
      facilitiesMixin__selectedFacilities: [],
      facilitiesMixin__allFacilitiesIds: [],
      facilitiesMixin__cities: []
    };
  },

  computed: {
    facilitiesMixin__selectedFacilitiesIds() {
      return this.facilitiesMixin__selectedFacilities.map(({ id }) => id);
    },
    facilitiesMixin__selectedFacilitiesCount() {
      return this.facilitiesMixin__selectedFacilities.length;
    },
    facilitiesMixin__gmbAddressesIds() {
      return this.facilitiesMixin__selectedFacilities.map(
        i => i.gmb_address_id
      );
    },
    facilitiesMixin__facilitiesIds() {
      return this.facilitiesMixin__selectedFacilities.map(i => i.id);
    },
    facilitiesMixin__isAllFacilitiesSelected() {
      if (this.$route.query.facility) return false;
      const selectedIds = this.facilitiesMixin__selectedFacilitiesIds;
      return this.facilitiesMixin__allFacilitiesIds
        .map(({ id }) => id)
        .every(id => selectedIds.includes(id));
    },
    facilitiesMixin__isAllCurrentPageFacilitiesSelected() {
      const selectedIds = this.facilitiesMixin__selectedFacilitiesIds;

      return this.facilitiesMixin__currentPageFacilities
        .filter(i => i.facilityListings && i.facilityListings.isOwner)
        .every(({ id }) => selectedIds.includes(id));
    }
  },
  methods: {
    facilitiesMixin__resetFacilities() {
      this.facilitiesMixin__totalCount = 0;
      this.facilitiesMixin__currentPageFacilities = [];
      this.facilitiesMixin__selectedFacilities = [];
      this.facilitiesMixin__allFacilitiesIds = [];
      this.facilitiesMixin__cities = [];
    },

    async facilitiesMixin__initFacilities({
      page = 1,
      perPage,
      isOwner = true,
      allFacilitiesIsOwner = isOwner, // variable to prevent checking facilities with no `isOwner` flag set to true
      isVerified = false,
      externalChangesStatuses = [],
      facilitiesIds = [],
      groups = [],
      openStatus = null
    }) {
      await this.facilitiesMixin__fetchAllFacilitiesIds({
        isOwner: allFacilitiesIsOwner,
        isVerified
      });
      await this.facilitiesMixin__fetchFacilities({
        page,
        perPage,
        isOwner,
        isVerified,
        externalChangesStatuses,
        facilitiesIds,
        groups,
        openStatus
      });
      this.facilitiesMixin__selectFacilities([]);
    },

    async facilitiesMixin__fetchFacilities(
      {
        page,
        perPage,
        query = null,
        isOwner = true,
        allFacilitiesIsOwner = isOwner,
        isVerified = false,
        externalChangesStatuses = [],
        cities = [],
        facilitiesIds = [],
        groups = [],
        locationState = null,
        openStatus = null,
        fetchAllFacilitiesIds = false // condition needed for `check all` functionallity on facilities lists with filtering
      },
      alterSelection = false
    ) {
      const facilities = await serviceHandler(
        facilitiesService.getFacilitiesData({
          page,
          perPage,
          query,
          is_owner: isOwner,
          is_verified: isVerified,
          external_changes_status: externalChangesStatuses,
          cities: cities,
          facilities_ids: facilitiesIds,
          groups: groups,
          location_state: locationState,
          open_status: openStatus
        })
      );

      if (fetchAllFacilitiesIds) {
        await this.facilitiesMixin__fetchAllFacilitiesIds({
          query,
          isOwner: allFacilitiesIsOwner,
          isVerified,
          externalChangesStatuses,
          facilitiesIds,
          cities: cities,
          groups,
          locationState,
          openStatus
        });
      }

      if (alterSelection) {
        this.facilitiesMixin__selectFacilities();
      }

      const data = facilities.results.map((facility, index) =>
        createFacilityModel(facility, index + 1 + (page - 1) * perPage)
      );
      this.facilitiesMixin__currentPageFacilities = data;

      this.facilitiesMixin__totalCount = facilities.count;
    },

    async facilitiesMixin__fetchAllFacilitiesIds({
      isVerified = false,
      query = null,
      externalChangesStatuses = [],
      facilitiesIds = [],
      cities = [],
      groups = [],
      locationState = null,
      openStatus = null,
      isOwner = false
    }) {
      const ids = await serviceHandler(
        facilitiesService.getFacilitiesIds({
          query,
          is_owner: isOwner,
          is_verified: isVerified,
          external_changes_status: externalChangesStatuses,
          cities: cities,
          facilities_ids: facilitiesIds,
          groups: groups,
          location_state: locationState,
          open_status: openStatus,
          has_physical_location: this.disableAreaFacilities
        })
      );

      this.facilitiesMixin__allFacilitiesIds = ids;
    },

    facilitiesMixin__selectFacilities(
      facilities = this.facilitiesMixin__allFacilitiesIds
    ) {
      if (facilities.length === 1 && !facilities[0].gmb_address_id) {
        const facilityWithGmbId = this.facilitiesMixin__allFacilitiesIds.find(
          item => item.id == facilities[0].id
        );
        this.facilitiesMixin__selectedFacilities = [facilityWithGmbId];
        return;
      }

      this.facilitiesMixin__selectedFacilities = [...facilities];
    },

    facilitiesMixin__selectFacilitiesByGmbAddressIds(gmbAddressIds) {
      const selected = this.facilitiesMixin__allFacilitiesIds.filter(
        ({ gmb_address_id }) => gmbAddressIds.includes(gmb_address_id)
      );
      this.facilitiesMixin__selectFacilities(selected);
    },

    facilitiesMixin__selectFacilitiesByFacilitiesIds(facilitiesIds) {
      const selected = this.facilitiesMixin__allFacilitiesIds.filter(({ id }) =>
        facilitiesIds.includes(id)
      );
      this.facilitiesMixin__selectFacilities(selected);
    },

    facilitiesMixin__toggleFacility(facility) {
      const selected = [...this.facilitiesMixin__selectedFacilities];
      const foundIndex = selected.findIndex(({ id }) => {
        return id === facility.id;
      });

      if (foundIndex !== -1) {
        selected.splice(foundIndex, 1);
      } else {
        const foundFacilityIds = this.facilitiesMixin__allFacilitiesIds.find(
          ({ id }) => facility.id === id
        );
        if (foundFacilityIds) selected.push(foundFacilityIds);
      }

      this.facilitiesMixin__selectFacilities(selected);
    },

    facilitiesMixin__toggleAllFacilities() {
      if (!this.facilitiesMixin__isAllFacilitiesSelected) {
        this.facilitiesMixin__selectFacilities();
      } else {
        this.facilitiesMixin__selectFacilities([]);
      }
    },

    facilitiesMixin__toggleAllCurrentPageFacilities() {
      const selected = [...this.facilitiesMixin__selectedFacilities];
      const currentPageFacilitesIds = this.facilitiesMixin__currentPageFacilities
        .filter(facility => facility.facilityListings.isOwner)
        .map(({ id }) => id);

      const currentPage = this.facilitiesMixin__allFacilitiesIds.filter(
        ({ id }) => currentPageFacilitesIds.includes(id)
      );

      if (!this.facilitiesMixin__isAllCurrentPageFacilitiesSelected) {
        currentPage.forEach(currentItem => {
          if (!selected.some(({ id }) => id === currentItem.id)) {
            selected.push(currentItem);
          }
        });
      } else {
        currentPage.forEach(currentItem => {
          const selectedIndex = selected.findIndex(
            ({ id }) => id === currentItem.id
          );

          if (selectedIndex > -1) {
            selected.splice(selectedIndex, 1);
          }
        });
      }

      this.facilitiesMixin__selectFacilities(selected);
    },

    async facilitiesMixin__fetchCities() {
      const result = await serviceHandler(
        facilitiesService.getFacilitiesCities()
      );
      this.facilitiesMixin__cities = result.map(({ city }) => city);
    }
  }
};
